import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
// import { LoginFormComponent } from './login/login-form/login-form.component';
import { AuthGuard } from './auth/auth.guard';
import { ErrorPagesComponent } from './error-pages/error-pages.component';
// import { VerifyTokenComponent } from './verification/verify-token/verify-token.component';
import { PayReturnComponent } from "./pay-return/pay-return.component";

const routes: Routes = [
  // {
  //   path: 'u', loadChildren: () => import('./user/user.module').then(m => m.UserModule),
  //   canLoad: [AuthGuard]
  // }, // lazy loading
  // {
  //   path: 'r', loadChildren: () => import('./restaurant/restaurant.module').then(m => m.RestaurantModule),
  //   canLoad: [AuthGuard]
  // },
  {
    path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad: [AuthGuard]
  },
  { path: 'in', loadChildren: () => import('./client/client.module').then(m => m.ClientModule) },
  { path: 'new', loadChildren: () => import('./register/register.module').then(m => m.RegisterModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'error', component: ErrorPagesComponent },
  { path: 'verify', loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule) },
  // { path: 'dash', component: MainDashboardComponent },
  { path: 'return', component: PayReturnComponent },
  { path: '', loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule) },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
